import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export function LocalTeaLogo({
  size = 48,
  className,
  title = 'LocalTea',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="lt-l5bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1D0D31" />
          <stop offset="100%" stopColor="#A8278C" />
        </linearGradient>
      </defs>
      <rect x="5" y="5" width="90" height="90" rx="18" fill="url(#lt-l5bg)" />
      {/* steam lines (gold) */}
      <path
        d="M36 28 Q 32 22 36 16 Q 40 10 36 6"
        stroke="#E8B73D"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        opacity="0.9"
      />
      <path
        d="M50 26 Q 46 20 50 14 Q 54 8 50 4"
        stroke="#E8B73D"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M64 28 Q 60 22 64 16 Q 68 10 64 6"
        stroke="#E8B73D"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        opacity="0.9"
      />
      {/* sparkle at top of middle steam */}
      <circle cx="50" cy="6" r="2.5" fill="#E8B73D" />
      {/* teacup body (tea-green) */}
      <path
        d="M24 36 L24 58 Q 24 74 38 78 L62 78 Q 76 74 76 58 L76 36 Z"
        fill="#6EE7B7"
        stroke="#6EE7B7"
        strokeWidth="2"
      />
      {/* cup handle */}
      <path
        d="M76 44 Q 88 44 88 54 Q 88 64 76 64"
        fill="none"
        stroke="#6EE7B7"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* saucer */}
      <ellipse cx="50" cy="82" rx="32" ry="3" fill="#6EE7B7" opacity="0.85" />
      {/* tea inside cup (darker for depth) */}
      <ellipse cx="50" cy="38" rx="24" ry="3" fill="#1D0D31" opacity="0.35" />
    </svg>
  );
}
